export enum Devices {
	desktop = 'desktop',
	mobile = 'mobile',
	tablet = 'tablet',
}

export enum MinScreenSizes {
	mobile = 280,
	tablet = 450,
	desktop = 1024,
}

export type IDevice = keyof typeof Devices;
